import dayjs from 'dayjs';

import { EBookingStatus } from '../../types';
import { ESessionType, Host, IBookingsResponse, IHostBooking } from './types';

const getNormalizeBooking = (
  bookingsResponse: IBookingsResponse | undefined,
  sortedHosts: Host[]
): Array<IHostBooking> => {
  const savedUUIDMap: Record<string, boolean> = {};
  const normalizedBookings: Array<IHostBooking> = [];

  bookingsResponse?.getBookings.data.forEach((booking) => {
    if (savedUUIDMap[booking.group] && booking.group) return;
    if (booking.status === EBookingStatus.CANCELED) return;
    if (booking.status === EBookingStatus.REDEEMED) return;

    if (booking.group) {
      savedUUIDMap[booking.group] = true;
    }

    booking.hostIds.forEach((hostId) => {
      const host = sortedHosts.find((host) => host.id === hostId);
      if (!host) return;
      normalizedBookings.push({
        ...booking,
        host: {
          id: hostId,
          alias: host.alias,
        },
        type: booking.byClient
          ? ESessionType.ONLINE_BOOKING
          : ESessionType.BOOKING,
      });
    });
  });

  return normalizedBookings;
};

const getHostSenses = (
  hostsOverview: Array<Host> | undefined,
  date: string | null,
  timezone: number
): Array<IHostBooking> => {
  const normalizedBookings: Array<IHostBooking> = [];

  hostsOverview
    ?.filter(({ client_sessions }) => client_sessions.length !== 0)
    .forEach((host) => {
      const { id, alias, client_sessions, user } = host;

      const startDate = dayjs(date).format('YYYY-MM-DD 00:00:00');
      const finishDate = dayjs(date)
        .add(1, 'days')
        .format('YYYY-MM-DD 12:00:00');

      const finishAt = dayjs()
        .utcOffset(0)
        .utcOffset(timezone)
        .add(client_sessions[0].time_left, 'seconds')
        .format('YYYY-MM-DD HH:mm:ss');

      if (
        !dayjs(client_sessions[0].started_at).isBetween(
          dayjs(startDate),
          dayjs(finishDate)
        ) &&
        !dayjs(finishAt).isBetween(dayjs(startDate), dayjs(finishDate)) &&
        !dayjs(startDate).isBetween(
          dayjs(client_sessions[0].started_at),
          dayjs(finishAt)
        ) &&
        !dayjs(finishDate).isBetween(
          dayjs(client_sessions[0].started_at),
          dayjs(finishAt)
        )
      )
        return;

      const curSession: IHostBooking = {
        host: {
          id,
          alias,
        },
        from: client_sessions[0].started_at,
        to: finishAt,
        type: ESessionType.CLIENT_SESSION,
        client: user,
        hostIds: [id],
        status: EBookingStatus.ACTIVE,
        group: '',
        id: client_sessions[0].id,
      };

      normalizedBookings.push(curSession);
    });

  return normalizedBookings;
};

export { getNormalizeBooking, getHostSenses };
